export enum VenueStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
}
